import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class EduProjectService extends BaseService {
    constructor(
        private http: HttpClient
    ) {
        super();
    }

    // Cơ bản
    getListEduProject() {
        return this.http.get(this.BaseURI + '/EduProject/List');
    }

    getListType() {
        return this.http.get(this.BaseURI + '/EduProject/ListType');
    }

    getEduProjectById(guid: any) {
        return this.http.get(this.BaseURI + '/EduProject/' + guid);
    }

    deleteEduProject(guid: any) {
        return this.http.delete(this.BaseURI + '/EduProject/' + guid);
    }

    saveEduProject(proj: any, formData: any) {
        formData.append('project', JSON.stringify(proj));

        if (proj.guid && proj.guid.length > 0)
            return this.http.put(this.BaseURI + '/EduProject', formData);
        else
            return this.http.post(this.BaseURI + '/EduProject', formData);
    }

    uploadDrive(formData: any) {
        return this.http.post(this.BaseURI + '/EduProject/UploadDrive', formData, { reportProgress: true, observe: 'events' });
    }

    uploadFeatureImage(formData: any) {
        return this.http.post(this.BaseURI + '/EduProject/UploadFeatureImage', formData, { reportProgress: true, observe: 'events' });
    }

    changeLinkDownloadSubEduProject(item: any) {
        return this.http.post(this.BaseURI + '/EduProject/ChangeLinkDownloadSub', item);
    }

    // Ảnh
    getListProjectImage(guid: any) {
        return this.http.get(this.BaseURI + '/EduProject/' + guid + '/ListProjectImage');
    }

    deleteEduProjectImage(guid: any) {
        return this.http.delete(this.BaseURI + '/EduProject/EduProjectImage/' + guid);
    }

    // Phê duyệt
    getlistApprovalEduProject(guidProj: any) {
        return this.http.get(this.BaseURI + '/EduProject/ListApprovalEduProject/' + guidProj);
    }

    approvalEduProject(approvalItem: any) {
        return this.http.post(this.BaseURI + '/EduProject/ApprovalEduProject', approvalItem);
    }

    activeEduProject(guid: any) {
        return this.http.get(this.BaseURI + '/EduProject/ActiveEduProject/' + guid);
    }
}